import React, {Fragment} from 'react';
import {notify} from "../../common/primitives/Notification/Notification";
import BaseComponent, {AjaxParam} from '../../common/BaseComponent/BaseComponent';

import TextBox from '../../common/primitives/TextBox'
import Submit from "../../common/primitives/Submit";

import styles from './ComponentOrderPromoCode.scss';

import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import LoadingRow from "../../common/primitives/LoadingRow";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import RemovePromoCodeMessage from "./RemovePromoCodeMessage";
import {__t} from '../../common/lang/text-resource';

class ComponentOrderPromoCode extends BaseComponent {
	promoCodeApplied = (this.props.data.componentData.promoCode !== '');
	promoCode = this.props.data.componentData.promoCode;
	innerLoading = false;
	showPromoCodeForm = false;

	constructor(props) {
		super(props);

		this.handlePromoCodeInSession();
	}

	togglePromoCodeForm = () => {
		this.showPromoCodeForm = !this.showPromoCodeForm;
		this.forceUpdate();
	};

	promoCodeChange = event => {
		this.promoCode = event.target.value;
		this.forceUpdate();
	};

	applyPromoCode = e => {
		e.preventDefault();
		this.innerLoading = true;
		this.forceUpdate();

		let ajaxParam = new AjaxParam();
		ajaxParam.isLoading = false;
		ajaxParam.callbackSuccess = (data) => {

			this.promoCodeApplied = true;
			this.innerLoading = false;

			this.handlePromoCodeInSession(true);

			this.rootPage().setState(data);
			//notify.success(this.messages.PROMO_CODE_APPLIED_SUCCESS);
		};
		ajaxParam.callbackError = (data) => {
			const {componentErrors} = data;
			const errorMessage = componentErrors[0];
			notify.error(this.messages[errorMessage] || errorMessage);
			this.innerLoading = false;
			this.forceUpdate();
		};

		this.rootPage().ajaxCall('ActionPromoCodeApply', {promoCode: this.promoCode}, ajaxParam);
	};

	removePromoCode = () => {

		let ajaxParam = new AjaxParam();
		ajaxParam.isLoading = false;
		ajaxParam.callbackSuccess = (data) => {
			this.promoCodeApplied = false;
			this.promoCode = '';
			localStorage.setItem('PromoCodeData', JSON.stringify({
				promoCode: this.promoCode,
				isAuto: false,
				isVisible: false
			}));
			this.rootPage().setState(data);
		};

		ajaxParam.callbackError = (data) => {
			const {componentErrors} = data;
			const errorMessage = componentErrors[0];
			notify.error(this.messages[errorMessage] || errorMessage);
		};

		this.rootPage().ajaxCall('ActionPromoCodeRemove', {}, ajaxParam);
	};

	handlePromoCodeInSession = (manuallyApplied) => {
		const promoCodeSessionData = JSON.parse(localStorage.getItem('PromoCodeData'));
		//Ако няма данни в сесията, правим го автоматично добавен
		if (!promoCodeSessionData) {
			localStorage.setItem('PromoCodeData', JSON.stringify({
				promoCode: this.promoCode.toLowerCase(),
				isAuto: manuallyApplied !== true && this.promoCode !== '',
				isVisible: false,
			}));
			return null;
		}
		//ръчно добавен промокод
		if (manuallyApplied) {
			localStorage.setItem('PromoCodeData', JSON.stringify({
				promoCode: this.promoCode.toLowerCase(),
				isAuto: false,
				isVisible: true
			}));
			return null;
		}

		//ако сегашния промокод е различен от този в сесията, значи автоматично е сменен промокода.
		if (promoCodeSessionData.promoCode !== this.promoCode && manuallyApplied !== true) {
			localStorage.setItem('PromoCodeData', JSON.stringify({
				promoCode: this.promoCode.toLowerCase(),
				isAuto: this.promoCode !== '',
				isVisible: false
			}));
			return null;
		}
	};

	togglePromoCodeContainer = () => {
		const promoCodeSessionData = JSON.parse(localStorage.getItem('PromoCodeData'));
		promoCodeSessionData.isVisible = !promoCodeSessionData.isVisible;
		localStorage.setItem('PromoCodeData', JSON.stringify(promoCodeSessionData));
		this.forceUpdate();
	};

	render() {

		const data = this.context.get(this.componentName);
		let allRowsWithPromo = false;
		if (data) {
			allRowsWithPromo = data.componentData.allRowsWithPromo;
		}
		const promoCodeSessionData = JSON.parse(localStorage.getItem('PromoCodeData'));

		if (this.innerLoading) {
			return (
			  <section className={styles.container}>
				  <div data-layout={'row center middle'} style={{minHeight: '122px'}}>
					  <div data-layout='col 12'>
						  <div className={styles.loadingContainer}>
							  <LoadingRow/>
						  </div>
					  </div>
				  </div>
			  </section>
			)
		}


		if (this.promoCodeApplied) {
			return (
			  <section className={styles.textContainer}>

				  <RemovePromoCodeMessage
					name='RemovePromoCodePopup'
					isVisible={false}
					removePromoCode={this.removePromoCode}
					promoCode={this.promoCode}/>

				  {
					promoCodeSessionData.isAuto &&
					<div>
						{__t('цените-са-с-автоматично-приложен-промо-код-за-отс315a78')}&nbsp;
						<Button
						  onClick={this.togglePromoCodeContainer}
						  name={'show_additional_promocode_details'}
						  value={promoCodeSessionData.isVisible ? __t('Скриване') : __t('Показване')}
						  className={`${buttons.buttonLink} ${buttons.action}`}/>
					</div>
				  }
				  {
					promoCodeSessionData.isVisible &&
					<section>
						<h1>{__t('Промоционален код')}</h1>
						<div className={styles.readOnlyContainer}>
							<p>
								{allRowsWithPromo === true ?
								  __t('цените-са-с-отстъпка-вследствие-на-приложен-промо47ac10')
								  :
								  (
									<Fragment>
										{__t('отстъпката-от-промо-код-се-прилага-за-услугите-за238cd2')}
										<br/>
										{__t('Отстъпката не важи за премиум домейни.')}
									</Fragment>
								  )
								}
							</p>
							<div>
								<span>{this.promoCode}</span>
							</div>
							<Button
							  onClick={() => this.eventRaise('ShowRemovePopupMessage', {
								  popupName: 'RemovePromoCodePopup',
								  replaceField: '%!promo_code!%',
								  replaceValue: this.promoCode
							  })}
							  name={'show_additional_promocode_details'}
							  value={__t('Промяна/изтриване на промокод')}
							  className={`${buttons.buttonLink} ${buttons.action}`}/>
						</div>
					</section>
				  }
			  </section>
			)
		}

		if (this.showPromoCodeForm) {
			return (
			  <section className={styles.container}>
				  <h1>{__t('Промоционален код')}</h1>
				  <form onSubmit={this.applyPromoCode} data-test='promo-code-form'>

					  <div data-layout="margin-bottom--smm">

						  <TextBox
							name={'order_promocode'}
							value={this.promoCode}
							readonly={this.promoCodeApplied}
							onChange={this.promoCodeChange}/>

					  </div>

					  <Submit
						value={__t('Прилагане на кода')}
						disabled={(this.promoCode === '')}/>
					  <br/>
				  </form>
			  </section>
			);
		}
		return (
		  <Button
			onClick={this.togglePromoCodeForm}
			name='showPromoCodeForm'
			testId={'show-promo-code-form-button'}
			className={`${buttons.buttonLink} ${buttons.action}`}
			value={__t('Въвеждане на промoционален код')}/>
		);
	}
}

ComponentOrderPromoCode.propTypes = {};


// React Context binding
ComponentOrderPromoCode.contextType = ContextDataStore;

export default ComponentOrderPromoCode;